var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-switch',{attrs:{"active-color":"#13ce66"},on:{"change":_vm.changeValue},model:{value:(_vm.paidValue),callback:function ($$v) {_vm.paidValue=$$v},expression:"paidValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }